var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Акты сверки")])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "table-settings",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Колонки\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "ml-1",
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.isBusy
                          },
                          on: {
                            click: function($event) {
                              return _vm.onCreate()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "plus" }
                          }),
                          _vm._v(" "),
                          _vm.isBusy
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n            Новый\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { variant: "light" } },
        [
          _c(
            "b-navbar-nav",
            [
              _c("filters-drawer", {
                attrs: {
                  query: _vm.filters.query,
                  "is-busy": _vm.isBusy,
                  "hide-search-button": ""
                },
                on: {
                  "update:query": function($event) {
                    return _vm.$set(_vm.filters, "query", $event)
                  },
                  submit: _vm.onSearch
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "reconciliation_acts",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "reconciliation-acts",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "no-local-sorting": "",
          "sticky-header": "",
          "head-variant": "light"
        },
        on: {
          "sort-changed": _vm.sortChanged,
          "row-dblclicked": _vm.onRowClicked
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(create_date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.create_date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(period)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.start_period)) +
                    " - " +
                    _vm._s(_vm.formatTableDate(row.item.end_period)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-btn",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.onEdit(row.item)
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "reconciliationAct_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a87508f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a87508f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReconciliationActs/ReconciliationActs.vue
// module id = null
// module chunks = 